import { Card } from '../../../Common/Charts/Card';
import { number } from '../../../Common/Util/number';
import { useHomelessChartsDataContext } from './hooks/useHomelessChartsDataContext';

export const Indicators = () => {
    const { chartData } = useHomelessChartsDataContext();

    return (
        <div
            className="w-100"
            style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}
        >
            <Card
                title="Total de Pessoas em Situação de Rua"
                value={number.formatToBRNumber(
                    chartData?.indicators?.homeless || 0
                )}
            />
            <Card
                title="Média de Pessoas em Situação de Rua por Família"
                value={number.formatToBRNumber(
                    chartData?.indicators?.averageOfHomelessPerFamily || 0
                )}
            />
        </div>
    );
};
